import {
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useRef, useState } from 'react'
import { santizeHtml } from '../../models/Common'
import { onKeyPressHandler } from '../../utilities/commonFunctions'
import Conditional from './Conditional'
import './HtmlTooltip.css'

export interface IHtmlTooltipProps {
  html: string
  defaultIconText?: string
}

const HtmlTooltip = (props: IHtmlTooltipProps) => {
  const mountedRef = useRef(false)
  const [icon, setIcon] = useState(props.defaultIconText || '?')
  const [showText, setShowText] = useState(false)

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      if (props.defaultIconText) {
        setIcon(props.defaultIconText)
      }
    }
    return () => {
      mountedRef.current = false
    }
  }, [])

  const htmlObj = { __html: santizeHtml(props.html, { ADD_ATTR: ['target'] }) }

  return (
    <>
      <span
        onClick={() => setShowText(!showText)}
        onKeyPress={onKeyPressHandler}
        tabIndex={0}
        role="button"
        className="button-tooltip"
      >
        <Conditional if={icon == '!'}>
          <FontAwesomeIcon
            className="ml-xs"
            icon={faExclamationTriangle}
            size={'1x'}
            color={'#da291c'}
          />
        </Conditional>
        <Conditional if={icon == '?'}>
          <FontAwesomeIcon
            className="ml-xs"
            icon={faInfoCircle}
            size={'lg'}
            color={'#1b365d'}
          />
        </Conditional>
      </span>
      {showText && (
        <div
          className="hint"
          style={{ display: 'block' }}
          dangerouslySetInnerHTML={htmlObj}
        ></div>
      )}
    </>
  )
}

export default HtmlTooltip
